import script from "./GlobusTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusTextArea.vue?vue&type=script&setup=true&lang=js"

import "./GlobusTextArea.vue?vue&type=style&index=0&id=379fe53a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379fe53a"]])

export default __exports__